export default {"src":"/_next/static/media/BTU.a492d6ce.svg","height":18,"width":18};